module.exports = __webpack_public_path__ + "assets/EqualSegments3Detailed.1b46ac4e65c548f67da3ca6451d78856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EqualSegments3Detailed.png
// module id = 504
// module chunks = 0